const tablebaocaoStyle = () => ({
  table: {
    width: "100%",
    height: "500px",
    fontSize: "14px",
    overflow: "auto",
    lineHeight: "normal",
    border: "1px solid #aaa",
    marginTop: "5px",
    whiteSpace: "break-spaces",
  },
  tableprint: { textAlign: "-webkit-center", paddingTop: "20px" },
  titleheader: { fontWeight: "bold" },
  tablebcsotandan: {
    textAlign: "center",
    width: "100%",
    fontSize: "13px",
    borderSpacing: "0",
    borderCollapse: "collapse",
  },
  tablebcsotandanclass: {
    textAlign: "center",
    width: "90%",
    fontSize: "13px",
    borderSpacing: "0",
    borderCollapse: "collapse",
  },
  tablebcsotandan_th: {
    border: "1px solid #4f7edb",
    textAlign: "center",
    borderColor: "#aaaaaa",
    borderStyle: "solid",
    backgroundImage: "linear-gradient(to bottom, #dedede , #ffffff)",
  },
  tablebcdiemsotan_th: {
    border: "1px solid #4f7edb",
    textAlign: "center",
    borderColor: "#aaaaaa",
    borderStyle: "solid",
    backgroundImage: "linear-gradient(to bottom, #dedede , #ffffff)",
  },
  tablebrutgon_th: {
    border: "1px solid #4f7edb",
    textAlign: "center",
    borderColor: "#aaaaaa",
    borderStyle: "solid",
    backgroundImage: "linear-gradient(to bottom, #dedede , #ffffff)",
  },
  tablebcsotandan_number_th: {
    border: "1px solid #4f7edb",
    textAlign: "center",
    borderColor: "#aaaaaa",
    borderStyle: "solid",
    backgroundImage: "linear-gradient(to bottom, #dedede , #ffffff)",
    color: "#008c25",
  },
  tablebcsotandan_td: {
    border: "1px solid #4f7edb",
    color: "#00ec00",
    fontWeight: "700",
    textAlign: "left",
  },
  tablebcsotandan_td_number: {
    border: "1px solid #4f7edb",
    color: "#00ec00",
    fontWeight: "700",
    textAlign: "right",
  },
  tablebcsotandan_td_cap: {
    border: "1px solid #4f7edb",
    color: "#ff9e00",
    fontWeight: "700",
    textAlign: "left",
  },
  tablebcsotandan_td_cap_number: {
    border: "1px solid #4f7edb",
    color: "#ff9e00",
    fontWeight: "700",
    textAlign: "right",
  },
  tablesotan_td: {
    border: "0.1px solid #4f7edb",
    color: "#161b26",
    fontWeight: "400",
    textAlign: "left",
  },
  tablesotan_td_bold: {
    border: "0.1px solid #4f7edb",
    color: "#161b26",
    fontWeight: "bold",
    textAlign: "left",
  },
  tablesotan_td_number: {
    border: "0.1px solid #4f7edb",
    color: "#161b26",
    fontWeight: "400",
    textAlign: "right",
  },
  tablebcdiemsotan: {
    textAlign: "center",
    width: "100%",
    fontSize: "13px",
    borderSpacing: "0",
    borderCollapse: "collapse",
  },
  tablediemsotan_td: {
    border: "0.1px solid #4f7edb",
    color: "#161b26",
    fontWeight: "400",
    textAlign: "left",
  },
  tablediemsotan_td_number: {
    border: "0.1px solid #4f7edb",
    color: "#161b26",
    fontWeight: "400",
    textAlign: "right",
  },
  tablebc_th_dn: {
    border: "1px solid #4f7edb",
    textAlign: "center",
    borderColor: "#aaaaaa",
    borderStyle: "solid",
    backgroundImage: "linear-gradient(to bottom, #0631bf , #5ef3f7)",
    height: "30px",
  },
  tablebc_th: {
    border: "1px solid #4f7edb",
    textAlign: "center",
    borderColor: "#aaaaaa",
    borderStyle: "solid",
    backgroundImage: "linear-gradient(to bottom, #dedede , #ffffff)",
  },
  tablebc_td: {
    border: "0.1px solid #4f7edb",
    color: "#161b26",
    fontWeight: "400",
    textAlign: "left",
  },
  tablebc_td_hh: {
    border: "0.1px solid #4f7edb",
    color: "#161b26",
    fontWeight: "400",
    textAlign: "left",
    borderRight: 0,
  },
  tablebc_td_end: {
    border: "0.1px solid #4f7edb",
    color: "#161b26",
    fontWeight: "400",
    textAlign: "left",
    borderLeft: "0px",
  },
  tablebc_td_dn: {
    border: "0.1px solid #4f7edb",
    color: "#161b26",
    textAlign: "left",
    height: "20px",
    wordWrap: "break-word",
    fontWeight: "400",
  },
  tablebc_td_dn_bold: {
    border: "0.1px solid #4f7edb",
    color: "#161b26",
    textAlign: "left",
    height: "20px",
    wordWrap: "break-word",
    fontWeight: "bold",
  },
  tablebc: {
    textAlign: "center",
    width: "100%",
    fontSize: "13px",
    borderSpacing: "0",
    borderCollapse: "collapse",
  },
  tieudecenter: {
    color: "black",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 16,
  },
  tieudeleft: {
    color: "black",
    textAlign: "left",
  },
  tieudeleftbold: {
    color: "black",
    textAlign: "left",
    fontWeight: "bold",
  },
  tieudephuongtien: {
    display: "block",
    textAlign: "center",
    color: "#00ca42",
    fontWeight: "bold",
    fontSize: 14,
    marginTop: 20,
  },
  tieudegpkd: {
    display: "block",
    textAlign: "center",
    color: "blue",
    fontWeight: "bold",
    fontSize: 16,
    marginTop: 10,
  },
  tieudegpkdred: {
    display: "block",
    textAlign: "center",
    color: "red",
    fontWeight: "bold",
    fontSize: 16,
    marginTop: 10,
  },
  button: {
    width: "100%",
    height: "30px",
    fontSize: "14px",
    overflow: "auto",
    border: "1px solid #aaa",
    backgroundColor: "#00733b",
    color: "#fff",
    borderRadius: "4px",
    lineHeight: "1.75",
  },
});

export default tablebaocaoStyle;
